function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 0.5rem;\n  line-height: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: top;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import Label from "../../../../label";
import { FiMoreHorizontal } from "react-icons/fi";
import Datepicker from "../../../../datepicker";
import { connect as connectFormik, getIn } from "formik";
import { getLocalizedProperty } from "../../../../../utils/i18n";
import { MutedText } from "../../../../text";
var IconContainer = styled.span(_templateObject());
var DatepickerContainer = styled.div(_templateObject1());
var DatepickerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(DatepickerComponent, PureComponent);
    var _super = _createSuper(DatepickerComponent);
    function DatepickerComponent() {
        _classCallCheck(this, DatepickerComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderEndInput = function() {
            var _props = _this.props, row = _props.row, formik = _props.formik;
            var name = row.id + "_end";
            var value = getIn(formik.values, name);
            var touched = getIn(formik.touched, name);
            var error = getIn(formik.errors, name);
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconContainer, null, /*#__PURE__*/ React.createElement(FiMoreHorizontal, null)), /*#__PURE__*/ React.createElement(Datepicker, {
                name: name,
                value: value,
                error: touched && error,
                setFieldValue: formik.setFieldValue
            }));
        };
        return _this;
    }
    var _proto = DatepickerComponent.prototype;
    _proto.render = function render() {
        var ref, ref1;
        var _props = this.props, row = _props.row, formik = _props.formik, disabled = _props.disabled, allowHelpText = _props.allowHelpText;
        var name = row.id;
        var value = getIn(formik.values, name);
        var touched = getIn(formik.touched, name);
        var error = touched ? getIn(formik.errors, name) : null;
        var rowLabel = getLocalizedProperty(row, "label");
        var label = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isRequired) ? "* ".concat(rowLabel) : rowLabel;
        var helpText = allowHelpText ? row.description : "";
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Label, null, label), Boolean(helpText) && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement(DatepickerContainer, null, /*#__PURE__*/ React.createElement(Datepicker, {
            name: name,
            error: error,
            value: value,
            disabled: Boolean(disabled),
            setFieldValue: formik.setFieldValue
        }), Boolean((ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.isDateRange) && this.renderEndInput()));
    };
    return DatepickerComponent;
}(PureComponent);
export default connectFormik(DatepickerComponent);
